import { type ToOptions, useRouter } from '@tanstack/react-router';

export const useBuildLocation = () => {
  const router = useRouter();
  return router.buildLocation as (options: ToOptions) => ReturnType<typeof router.buildLocation>;
};
